import {
  Table,
  TableHead,
  TableRow,
  TableCell,
  Typography,
  TableBody,
  List,
  ListItem,
  ListItemText,
  ListSubheader,
} from '@mui/material';
import useResponsive from 'hooks/useResponsive';
import { isEmpty } from 'lodash';
import type { ListProps, ListItemProps } from '@mui/material';
import type { FC, ReactNode } from 'react';

export interface Row {
  label: string;
  value: ReactNode;
}

export interface ResponsiveKeyValueListProps {
  title?: string;
  rows: Row[];
  ListProps?: ListProps;
  ListItemProps?: ListItemProps;
}

const TableView: FC<ResponsiveKeyValueListProps> = ({ title, rows }) => (
  <>
    <Table sx={{ maxWidth: '800px' }}>
      {!isEmpty(title) && (
        <TableHead>
          <TableRow>
            <TableCell component={'th'} colSpan={2}>
              <Typography variant='h6'>{title}</Typography>
            </TableCell>
          </TableRow>
        </TableHead>
      )}
      <TableBody>
        {rows.map(({ label, value }) => (
          <TableRow key={label}>
            <TableCell width={300}>{label}</TableCell>
            <TableCell>{value}</TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  </>
);

const ListView: FC<ResponsiveKeyValueListProps> = ({ title, rows, ...rest }) => (
  <List {...rest.ListProps}>
    {!isEmpty(title) && <ListSubheader>{title}</ListSubheader>}

    {rows.map((r, i) => (
      <ListItem {...rest.ListItemProps} key={`${r.label}-${i}`}>
        <ListItemText primary={r.label} secondary={r.value} />
      </ListItem>
    ))}
  </List>
);

const ResponsiveKeyValueList: FC<ResponsiveKeyValueListProps> = (props) => {
  const isSmallScreen = useResponsive('down', 'sm');

  return <>{isSmallScreen ? <ListView {...props} /> : <TableView {...props} />}</>;
};

export default ResponsiveKeyValueList;
